
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/hubspot",
      function () {
        return require("private-next-pages/whatsapp-integrations/hubspot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/hubspot"])
      });
    }
  